import { UtilityService } from '@eforall/common';
import { buildColumn, GridColumn } from '@eforall/dashboard';
import { AIPromptAndResponseWithUpdatedUTC } from '@interfaces';


export function getColumns(util: UtilityService) {


	const columns: GridColumn<AIPromptAndResponseWithUpdatedUTC, unknown>[] = [
		buildColumn(util, 'Id', row => row.aiPromptId, { header: 'aiPromptId' }),
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.personFullName, { header: 'Name', hidden: true }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture', hidden: true }),
		buildColumn(util, 'Text', row => row.userRolePhase, { header: 'Phase' }),
		buildColumn(util, 'Text', row => row.promptType, { header: 'Type' }),
		buildColumn(util, 'Text', row => row.promptAuthor, { header: 'Author' }),
		buildColumn(util, 'Text', row => row.blockedReason, { header: 'Blocked Reason' }),
		buildColumn(util, 'Text', row => row.blockedMessage, { header: 'Blocked Message' }),
		buildColumn(util, 'Text', row => row.error, { header: 'Error' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Date', hidden: true }),
	];

	return columns;

}
